// extracted by mini-css-extract-plugin
export default {"group":"Area_group__tHGDV"};